const publicId = process.env.REACT_APP_CLOUDPAYMENTS_PUBLIC_ID

const buildReceipt = (label, price) => {
  // email добавляется при нажатии на кнопку оплатить в компоненте
  return {
    Items: [
      // товарные позиции
      {
        label, // наименование товара
        price, // цена
        quantity: 1.0, // количество
        vat: 5, //ставка НДС 5%
        amount: price // сумма
      }
    ],
    isBso: false, // чек является бланком строгой отчётности
    taxationSystem: 2, // Система налогообложения: УСН доходы минус расходы https://developers.cloudkassir.ru/#taxationsystem
    amounts: {
      electronic: price // Сумма оплаты электронными деньгами
    }
  }
}

const buildWidgetData = (label, amount, invoiceId, data, email, accountId) => {
  // email and accountId добавляется при нажатии на кнопку оплатить в компоненте
  return {
    // options
    publicId, // тестовый id из личного кабинета
    description: label, // назначение
    amount, // сумма
    currency: 'RUB', //валюта
    invoiceId, // номер заказа  (необязательно)
    skin: 'classic', // "modern" дизайн виджета,
    email,
    accountId,
    data
  }
}

export const getWidgetData = (selectedProductId, discounts, activeWebTrialOfferPrices, extraTipCents) => {
  let appliedDiscountPromoCode = discounts.code
  const extraTip = (extraTipCents || 0) / 100

  const monthIntroductoryDiscount = (discounts.monthly_discount_cents || 0) / 100
  const yearIntroductoryDiscount = (discounts.yearly_discount_cents || 0) / 100
  const triennialIntroductoryDiscount = (discounts.triennial_discount_cents || 0) / 100
  const lifetimeIntroductoryDiscount = (discounts.lifetime_discount_cents || 0) / 100

  const kidsMonthIntroductoryDiscount = (discounts.kids_monthly_discount_cents || 0) / 100
  const kidsYearIntroductoryDiscount = (discounts.kids_yearly_discount_cents || 0) / 100
  const kidsThreeYearIntroductoryDiscount = (discounts.kids_triennial_discount_cents || 0) / 100
  const kidsLifetimeIntroductoryDiscount = (discounts.kids_lifetime_discount_cents || 0) / 100

  const packMonthIntroductoryDiscount = (discounts.pack_monthly_discount_cents || 0) / 100
  const packYearIntroductoryDiscount = (discounts.pack_yearly_discount_cents || 0) / 100
  const packThreeYearIntroductoryDiscount = (discounts.pack_triennial_discount_cents || 0) / 100
  const packLifetimeIntroductoryDiscount = (discounts.pack_lifetime_discount_cents || 0) / 100

  let label
  let regularPrice
  let introductoryPrice
  let introductoryReceipt
  let receipt

  switch (selectedProductId) {
    case 'monthly': {
      label = process.env.REACT_APP_ARZAMAS_MONTH_LABEL
      regularPrice = Number(process.env.REACT_APP_ARZAMAS_MONTH_PRICE)

      if (activeWebTrialOfferPrices['monthly'] && kidsMonthIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['monthly']
        appliedDiscountPromoCode = 'SPECIAL_2022_03'
      } else {
        introductoryPrice = regularPrice - monthIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'monthly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 1,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'yearly': {
      label = process.env.REACT_APP_ARZAMAS_YEAR_LABEL
      regularPrice = Number(process.env.REACT_APP_ARZAMAS_YEAR_PRICE)
      introductoryPrice = regularPrice - yearIntroductoryDiscount

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'yearly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 12,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'triennial': {
      label = process.env.REACT_APP_ARZAMAS_TRIENNIAL_LABEL
      regularPrice = Number(process.env.REACT_APP_ARZAMAS_TRIENNIAL_PRICE)
      introductoryPrice = regularPrice - triennialIntroductoryDiscount

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)

      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'triennial',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 36,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'lifetime': {
      label = process.env.REACT_APP_ARZAMAS_LIFETIME_LABEL
      regularPrice = Number(process.env.REACT_APP_ARZAMAS_LIFETIME_PRICE)
      introductoryPrice = regularPrice - lifetimeIntroductoryDiscount

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)

      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'lifetime',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            maxPeriods: 0,
            period: 12000,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }

    case 'kids_monthly': {
      label = process.env.REACT_APP_KIDS_MONTH_LABEL
      regularPrice = Number(process.env.REACT_APP_KIDS_MONTH_PRICE)

      let startDate = null
      if (activeWebTrialOfferPrices['kidsMonthly'] === 1 && kidsMonthIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['kidsMonthly']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по месячной подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else if (activeWebTrialOfferPrices['kidsMonthly'] && kidsMonthIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['kidsMonthly']
        appliedDiscountPromoCode = 'SPECIAL_2022_03'
      } else {
        introductoryPrice = regularPrice - kidsMonthIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'kids_monthly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 1,
            amount: regularPrice,
            customerReceipt: receipt,
            startDate: startDate
          }
        }
      })
    }
    case 'kids_yearly': {
      label = process.env.REACT_APP_KIDS_YEAR_LABEL
      regularPrice = Number(process.env.REACT_APP_KIDS_YEAR_PRICE)
      let startDate = null
      if (activeWebTrialOfferPrices['kidsYearly'] && kidsYearIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['kidsYearly']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - kidsYearIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'kids_yearly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 12,
            amount: regularPrice,
            customerReceipt: receipt,
            startDate: startDate
          }
        }
      })
    }
    case 'kids_triennial': {
      label = process.env.REACT_APP_KIDS_TRIENNIAL_LABEL
      regularPrice = Number(process.env.REACT_APP_KIDS_TRIENNIAL_PRICE)
      introductoryPrice = regularPrice - kidsThreeYearIntroductoryDiscount

      let startDate = null
      if (activeWebTrialOfferPrices['kidsTriennial'] && kidsThreeYearIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['kidsTriennial']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - kidsThreeYearIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'kids_triennial',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 36,
            amount: regularPrice,
            customerReceipt: receipt,
            startDate: startDate
          }
        }
      })
    }
    case 'kids_lifetime': {
      label = process.env.REACT_APP_KIDS_LIFETIME_LABEL
      regularPrice = Number(process.env.REACT_APP_KIDS_LIFETIME_PRICE)
      introductoryPrice = regularPrice - kidsLifetimeIntroductoryDiscount

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)

      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'kids_lifetime',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            maxPeriods: 0,
            period: 12000,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }

    case 'pack_monthly': {
      label = process.env.REACT_APP_PACK_MONTH_LABEL
      regularPrice = Number(process.env.REACT_APP_PACK_MONTH_PRICE)

      let startDate = null
      if (activeWebTrialOfferPrices['packMonthly'] && packMonthIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['packMonthly']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - packMonthIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'pack_monthly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 1,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'pack_yearly': {
      label = process.env.REACT_APP_PACK_YEAR_LABEL
      regularPrice = Number(process.env.REACT_APP_PACK_YEAR_PRICE)

      let startDate = null
      if (activeWebTrialOfferPrices['packYearly'] && packYearIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['packYearly']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - packYearIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'pack_yearly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 12,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'pack_triennial': {
      label = process.env.REACT_APP_PACK_TRIENNIAL_LABEL
      regularPrice = Number(process.env.REACT_APP_PACK_TRIENNIAL_PRICE)

      let startDate = null
      if (activeWebTrialOfferPrices['packTriennial'] && packThreeYearIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['packTriennial']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - packThreeYearIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'pack_triennial',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 36,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
    case 'pack_lifetime': {
      label = process.env.REACT_APP_PACK_LIFETIME_LABEL
      regularPrice = Number(process.env.REACT_APP_PACK_LIFETIME_PRICE)
      introductoryPrice = regularPrice - packLifetimeIntroductoryDiscount

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)

      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'pack_lifetime',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            maxPeriods: 0,
            period: 12000,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }

    default: {
      label = process.env.REACT_APP_PACK_YEAR_LABEL
      regularPrice = Number(process.env.REACT_APP_PACK_YEAR_PRICE)

      let startDate = null
      if (activeWebTrialOfferPrices['packYearly'] && packYearIntroductoryDiscount === 0) {
        introductoryPrice = activeWebTrialOfferPrices['packYearly']
        appliedDiscountPromoCode = 'WEB_TRIAL'
        // первое списание по годовой подписке для триала - через 2 недели
        startDate = new Date() //текущая дата
        startDate.setDate(startDate.getDate() + 14) // плюс 2 недели
      } else {
        introductoryPrice = regularPrice - packYearIntroductoryDiscount
      }

      if (extraTip) {
        introductoryPrice = introductoryPrice + extraTip
        regularPrice = regularPrice + extraTip
      }

      introductoryReceipt = buildReceipt(label, introductoryPrice)
      receipt = buildReceipt(label, regularPrice)
      return buildWidgetData(label, introductoryPrice, undefined, {
        payment_type: 'subscription',
        product_id: 'pack_yearly',
        discount_code: introductoryPrice === regularPrice ? null : appliedDiscountPromoCode,
        extra_tip_cents: extraTipCents,
        cloudPayments: {
          customerReceipt: introductoryReceipt,
          recurrent: {
            interval: 'Month',
            period: 12,
            amount: regularPrice,
            customerReceipt: receipt
          }
        }
      })
    }
  }
}

export const POSSIBLE_SUBSCRIPTION_TYPES = [
  { type: 'radio', logo: '#logo_radio' },
  { type: 'kids', logo: '#logo_gus_gus' },
  { type: 'pack', logo: '#logo_pack', promo: { desktop: 'Самый выгодный вариант', mobile: 'Самый выгодный вариант' } }
]

export const SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT = {
  kids_monthly: 'kids',
  kids_yearly: 'kids',
  kids_triennial: 'kids',
  kids_lifetime: 'kids',
  yearly: 'radio',
  monthly: 'radio',
  triennial: 'radio',
  lifetime: 'radio',
  pack_monthly: 'pack',
  pack_yearly: 'pack',
  pack_triennial: 'pack',
  pack_lifetime: 'pack',
  kids_and_radio_promo: 'pack',
  radio_promo: 'radio',
  kids_promo: 'kids'
}

// Варианты подписок new
export default [
  /* Радио */
  {
    type: 'radio',
    product: 'monthly',
    camelCaseId: 'monthly',
    price: Number(process.env.REACT_APP_ARZAMAS_MONTH_PRICE),
    title: 'в месяц',
    discountType: 'monthly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Arzamas» на нашем сайте, а также все курсы, подкасты и другое аудио в приложении «Радио Arzamas».'
  },
  {
    type: 'radio',
    product: 'yearly',
    camelCaseId: 'yearly',
    badgeRight: { desktop: '-37%', mobile: '-37%', percentages: 37 },
    price: Number(process.env.REACT_APP_ARZAMAS_YEAR_PRICE),
    title: 'в год',
    discountType: 'yearly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Arzamas» на нашем сайте, а также все курсы, подкасты и другое аудио в приложении «Радио Arzamas».'
  },
  {
    type: 'radio',
    product: 'triennial',
    camelCaseId: 'triennial',
    price: Number(process.env.REACT_APP_ARZAMAS_TRIENNIAL_PRICE),
    title: 'за 3 года',
    discountType: 'triennial_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Arzamas» на нашем сайте, а также все курсы, подкасты и другое аудио в приложении «Радио Arzamas».'
  },
  {
    type: 'radio',
    product: 'lifetime',
    camelCaseId: 'lifetime',
    price: Number(process.env.REACT_APP_ARZAMAS_LIFETIME_PRICE),
    title: 'навсегда',
    discountType: 'lifetime_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Arzamas» на нашем сайте, а также все курсы, подкасты и другое аудио в приложении «Радио Arzamas».'
  },
  /* Гусьгусь */
  {
    type: 'kids',
    product: 'kids_monthly',
    camelCaseId: 'kidsMonthly',
    price: Number(process.env.REACT_APP_KIDS_MONTH_PRICE),
    title: 'в месяц',
    discountType: 'kids_monthly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Гусьгусь» на нашем сайте, а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'kids',
    product: 'kids_yearly',
    camelCaseId: 'kidsYearly',
    badgeLeft: { desktop: '-44%', mobile: '-44%', percentages: 44 },
    price: Number(process.env.REACT_APP_KIDS_YEAR_PRICE),
    title: 'в год',
    discountType: 'kids_yearly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Гусьгусь» на нашем сайте, а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'kids',
    product: 'kids_triennial',
    camelCaseId: 'kidsTriennial',
    price: Number(process.env.REACT_APP_KIDS_TRIENNIAL_PRICE),
    title: 'за 3 года',
    discountType: 'kids_triennial_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Гусьгусь» на нашем сайте, а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'kids',
    product: 'kids_lifetime',
    camelCaseId: 'kidsLifetime',
    price: Number(process.env.REACT_APP_KIDS_LIFETIME_PRICE),
    title: 'навсегда',
    discountType: 'kids_lifetime_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы «Гусьгусь» на нашем сайте, а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  /* Комбо */
  {
    type: 'pack',
    product: 'pack_monthly',
    camelCaseId: 'packMonthly',
    price: Number(process.env.REACT_APP_PACK_MONTH_PRICE),
    title: 'в месяц',
    discountType: 'pack_monthly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы на нашем сайте, все курсы, подкасты и другое аудио в приложении «Радио Arzamas», а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'pack',
    product: 'pack_yearly',
    camelCaseId: 'packYearly',
    badgeRight: { desktop: '-32%', mobile: '-32%', percentages: 32 },
    price: Number(process.env.REACT_APP_PACK_YEAR_PRICE),
    title: 'в год',
    discountType: 'pack_yearly_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы на нашем сайте, все курсы, подкасты и другое аудио в приложении «Радио Arzamas», а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'pack',
    product: 'pack_triennial',
    camelCaseId: 'packTriennial',
    price: Number(process.env.REACT_APP_PACK_TRIENNIAL_PRICE),
    title: 'за 3 года',
    discountType: 'pack_triennial_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы на нашем сайте, все курсы, подкасты и другое аудио в приложении «Радио Arzamas», а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  },
  {
    type: 'pack',
    product: 'pack_lifetime',
    camelCaseId: 'packLifetime',
    price: Number(process.env.REACT_APP_PACK_LIFETIME_PRICE),
    title: 'навсегда',
    discountType: 'pack_lifetime_discount_cents',
    bottomText:
      ' Эта подписка дает возможность слушать любые курсы на нашем сайте, все курсы, подкасты и другое аудио в приложении «Радио Arzamas», а также все детские курсы, подкасты и другое аудио в приложении «Гусьгусь».'
  }
]
